import * as Yup from 'yup';

// Validate phone number
const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export function validateFormIntro() {
    const formIntroSchema = Yup.object().shape(
        {
            city: Yup.string()
                .min(3, 'The city must be at least 3 characters long')
                .max(50, 'The city is too long')
                .nullable(),
            country: Yup.string().nullable().required(),
            state: Yup.string().nullable().when('country', {
                is: 'US',
                then: Yup.string().nullable().required()
            }),
            title: Yup.string()
                .min(3, 'The title must be at least 3 characters long')
                .max(50, 'The title is too long')
                .nullable()
                .required(),
            company: Yup.string()
                .min(3, 'The company must be at least 3 characters long')
                .max(50, 'The company is too long')
                .nullable()
                .required(),
            companyDepartment: Yup.string()
                .min(3, 'The company must be at least 3 characters long')
                .max(50, 'The company is too long')
                .nullable()
                .required(),
            phone: Yup.string()
                .max(15)
                .nullable()
                .matches(phoneRegExp, 'Phone number is not valid'),
            linkedIn: Yup.string().nullable().required().url()
        },
        [['country', 'state']]
    );
    return formIntroSchema;
}

export function validateFormAbout() {
    return Yup.object().shape({
        solutions: Yup.string()
            .min(3, 'The Solutions must be at least 3 characters long')
            .max(50, 'The Solutions is too long')
            .nullable()
            .required(),
        about: Yup.string()
            .max(2000, 'The About is too long')
            .nullable()
            .required(),
        markets: Yup.string()
            .max(50, 'The About is too long')
            .nullable()
            .required(),
        businessCategory: Yup.string()
            .max(50, 'The Business Category is too long')
            .nullable()
            .required(),
        certificationsDesignation: Yup.string()
            .max(50, 'The Certifications and Designation is too long')
            .nullable(),
        awards: Yup.string().max(50, 'The Awards is too long').nullable(),
        assocationCommittees: Yup.string()
            .max(50, 'The Assocation Committees is too long')
            .nullable()
            .required(),
        volunteerInterests: Yup.string()
            .max(50, 'The Volunteer Interests is too long')
            .nullable()
    });
}
